import _ from 'lodash'
import { QRCodeSVG as QRCode } from 'qrcode.react'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../button'
import { useModal } from '../../hook/use-modal'
import useStyles from './token-button-style'

function TokenButtonView(props) {
  const {
    disabled,
    countDown,
    countDownInProgress,
    loading,
    qrCodeValue,
    showRedirectModal,
    type,
    onContinue,
    onContinueOnMobile,
    onContinueOnMobileSuccess,
    onDismiss,
    ...rest
  } = props
  const modal = useModal()
  const { t } = useTranslation()
  const styles = useStyles()

  let labelTranslationKey = 'ui.emailTokenButton.label'
  if (type === 'phone') {
    labelTranslationKey = 'ui.smsTokenButton.label'
  }
  if (type === 'whatsapp') {
    labelTranslationKey = 'ui.whatsappTokenButton.label'
  }

  useEffect(() => {
    if (showRedirectModal) {
      modal.open({
        title: t('ui.whatsappTokenButton.whatsappTokenVerificationRedirectModal.title'),
        html: t('ui.whatsappTokenButton.whatsappTokenVerificationRedirectModal.html'),
        buttons: [
          {
            text: t('ui.whatsappTokenButton.whatsappTokenVerificationRedirectModal.buttons.continue'),
            disabled: loading,
            onClick: onContinue,
          },
          {
            className: styles.continueOnMobileButton,
            dark: true,
            text: t('ui.whatsappTokenButton.whatsappTokenVerificationRedirectModal.buttons.continueOnMobile'),
            disabled: loading,
            onClick: onContinueOnMobile,
          },
          {
            text: t('ui.whatsappTokenButton.whatsappTokenVerificationRedirectModal.buttons.dismiss'),
            onClick: onDismiss,
            outline: true,
          },
        ],
        shouldCloseOnOverlayClick: false,
      })
    } else {
      modal.close()
    }
  }, [showRedirectModal])

  useEffect(() => {
    if (!_.isEmpty(qrCodeValue)) {
      modal.open({
        title: t('ui.whatsappTokenButton.whatsappTokenVerificationRedirectModal.buttons.continueOnMobile'),
        contentComponent: (
          <QRCode
            value={qrCodeValue}
            size={250}
          />
        ),
        buttons: [
          {
            text: t('ui.whatsappTokenButton.whatsappTokenVerificationRedirectModal.buttons.confirm'),
            onClick: onContinueOnMobileSuccess,
          },
        ],
      })
    } else {
      modal.close()
    }
  }, [qrCodeValue])

  return (
    <Button
      disabled={countDownInProgress || disabled || loading}
      text={t(labelTranslationKey, {
        count: countDown,
        context: countDown <= 0 ? '0' : '1', // FL: added context to i18n key since i18next's Plural function doesn't work.
      })}
      {...rest}
    />
  )
}

export default TokenButtonView
